// extracted by mini-css-extract-plugin
module.exports = {"QuizList":"QuizList__QuizList___kvD_d"};